// HELPERS
import { create_new_time_isostring } from "../../../../helpers/format_time";

/**
 * Handles what date range is eligble for selected banner/campaign
 **/
export function getReportingDateRestrictions(scope: string, data: { [key: string]: string }) {
  let minDate: string = "";
  let maxDate: string = "";
  if (scope === "banner") {
    minDate = data.CreatedUtc.split("T")[0];
    maxDate = create_new_time_isostring().split("T")[0];
  }
  if (scope === "campaign") {
    minDate = data.startDate.split("T")[0];
    maxDate = new Date() < new Date(data.endDate) ? create_new_time_isostring().split("T")[0] : data.endDate.split("T")[0];
  }
  return { minDate, maxDate };
}
